import { createI18n } from "vue-i18n";

const messages = {
  en: {
    header: {
      logoSuffix: "LIQUID",
      menu: {
        about: "ABOUT US",
        portfolio: "PORTFOLIO",
        experience: "EXPERIENCE",
        team: "TEAM",
        contact: "CONTACT US",
      },
      languageLabel: "Language",
      languages: {
        en: "English",
        es: "Español",
        fr: "Français",
        ru: "Русский",
      },
    },
    main: {
      underheader: "Where thoughts take shape and acquire meaning",
    },
    about: {
      title: "About Us",
      row1: {
        left: "WE ARE",
        right: "A TEAM OF EXPERTS",
      },
      row2: {
        left: "INSPIRED BY CUTTING-EDGE",
      },
      row3: {
        right: "TECHNOLOGIES AND",
      },
      row4: {
        left: "PRODUCT DEVELOPMENT",
      },
      stats: {
        experts: {
          number: "16",
          label: "EXPERTS ON BOARD",
        },
        released: {
          number: "10",
          label: "RELEASED PRODUCTS",
        },
        ongoing: {
          number: "1",
          label: "ONGOING PRODUCTS",
        },
        best: {
          number: "2",
          label: "BEST PROJECT",
        },
      },
    },
    experience: {
      title: "Experience",
      cards: {
        blockchain: {
          header: "Web Dev",
          description:
            "We build modern web applications and services, from landing pages to complex platforms. We focus on architecture, performance, and scalability for real business needs.",
        },
        uxui: {
          header: "WEB3 Dev",
          description:
            "We develop decentralized solutions: smart contracts, dApps, and blockchain integrations. We ensure security, transparency, and reliable web3 infrastructure.",
        },
        mobile: {
          header: "Telegram Dev",
          description:
            "We create Telegram apps, bots, and parsers of any complexity. We automate processes, collect data, and design seamless user interactions.",
        },
        qa: {
          header: "Scripts & Automation",
          description:
            "We develop scripts, panels, and dashboards tailored to specific tasks. We streamline workflows, speed up operations, and unify data into controlled systems.",
        },
        consulting: {
          header: "Backend & Architecture",
          description:
            "We design reliable backend solutions and APIs. We ensure stability, security, and readiness for high-load environments.",
        },
        data: {
          header: "Backend & Architecture",
          description:
            "We design reliable backend solutions and APIs. We ensure stability, security, and readiness for high-load environments",
        },
      },
    },
    projects: {
      title: "PROJECTS.",
      cards: {
        drainer: {
          header: "WEB3 Wallet",
          description:
            "A technologically impossible wallet that we managed to create.",
        },
        telegramPhish: {
          header: "Telegram Web App",
          description: "An incredible user experience in the field of Telegram web apps",
        },
        multiParser: {
          header: "Multi Parser",
          description:
            "A parser for ads across various platforms and Telegram channels.",
        },
      },
    },
    team: {
      title: "Team",
      positions: {
        founder: "Founder & CTO",
        marketing: "Chief Marketing",
        product: "Product Manager",
        backend: "Backend Lead",
        design: "Front-end Lead",
        community: "Senijor Dev",
      },
    },
    letsTalk: {
      title: "LET'S TALK",
    },
    footer: {
      privacy: "Privacy Policy",
      contacts: {
        linkedIn: "LinkedIn",
        dribbble: "Dribbble",
      },
      copyright: "©All rights reserved «Zero Liquid»",
    },
    mobileMenu: {
      joke:
        "Better to roar like a bear than to hiss like a traitor © PisyaPopa",
    },
    contact: {
      title: "Let's talk about your project",
      subtitle: "Describe your idea and we will come back with a solution",
      fields: {
        name: "How can we address you?",
        project: "Project name",
        description: "Short project description",
        budget: "Desired budget",
      },
      submit: "Contact manager",
      telegramMessage:
        "Hello! My name is {name}.\nI want to create {project}.\nA short description: {description}.\nBudget is {budget}",
      productMessage:
        "Hello! I am interested in your product {title}. Could you tell me more about it?",
    },
  },
  ru: {
    header: {
      logoSuffix: "LIQUID",
      menu: {
        about: "О НАС",
        portfolio: "ПОРТФОЛИО",
        experience: "ОПЫТ",
        team: "КОМАНДА",
        contact: "СВЯЗАТЬСЯ",
      },
      languageLabel: "Язык",
      languages: {
        en: "English",
        es: "Español",
        fr: "Français",
        ru: "Русский",
      },
    },
    main: {
      underheader: "Где мысли переходят в форму обретая смысл",
    },
    about: {
      title: "О нас",
      row1: {
        left: "WE ARE",
        right: "A TEAM OF EXPERTS",
      },
      row2: {
        left: "INSPIRED BY CUTTING-EDGE",
      },
      row3: {
        right: "TECHNOLOGIES AND",
      },
      row4: {
        left: "PRODUCT DEVELOPMENT",
      },
      stats: {
        experts: {
          number: "16",
          label: "ЭКСПЕРТОВ В КОМАНДЕ",
        },
        released: {
          number: "10",
          label: "ЗАПУЩЕННЫХ ПРОДУКТОВ",
        },
        ongoing: {
          number: "1",
          label: "ПРОЕКТ В РАБОТЕ",
        },
        best: {
          number: "2",
          label: "ЛУЧШИХ ПРОЕКТА",
        },
      },
    },
    experience: {
      title: "Опыт",
      cards: {
        blockchain: {
          header: "Веб разработка",
          description:
            "Мы создаём современные веб-приложения и сервисы: от лендингов до сложных платформ. Продумываем архитектуру, производительность и масштабируемость под задачи бизнеса.",
        },
        uxui: {
          header: "WEB3 разработка",
          description:
            "Разрабатываем децентрализованные решения: смарт-контракты, dApp и блокчейн-интеграции. Обеспечиваем безопасность, прозрачность и стабильную web3-инфраструктуру.",
        },
        mobile: {
          header: "Telegram dev",
          description:
            "Создаём Telegram-приложения, ботов и парсеры любой сложности. Автоматизируем процессы, собираем данные и улучшаем взаимодействие с пользователем.",
        },
        qa: {
          header: "Скрипты и автоматизация",
          description:
            "Разрабатываем скрипты, панели и дешборды под конкретные задачи. Оптимизируем процессы и объединяем данные в управляемые системы.",
        },
        consulting: {
          header: "Backend и архитектура",
          description:
            "Проектируем надёжные серверные решения и API. Обеспечиваем стабильность, безопасность и готовность к высоким нагрузкам.",
        },
        data: {
          header: "Комплексная разработка",
          description:
            "Берём на себя полный цикл: от идеи до поддержки продукта. Подбираем технологии и создаём решения, которые работают.",
        },
      },
    },
    projects: {
      title: "ПРОДУКТЫ.",
      cards: {
        drainer: {
          header: "WEB3 Wallet",
          description:
            "Технологически невозможный кошелек, который нам удалось создать",
        },
        telegramPhish: {
          header: "Telegram Web App",
          description:
            "Невероятный пользовательский опыт в области веб-приложений Telegram",
        },
        multiParser: {
          header: "Multi Parser",
          description:
            "Парсер для рекламы на различных платформах и в каналах Telegram",
        },
      },
    },
    team: {
      title: "Команда",
      positions: {
        founder: "Основатель и CTO",
        marketing: "Руководитель маркетинга",
        product: "Продукт‑менеджер",
        backend: "Руководитель backend",
        design: "Руководитель Front-end",
        community: "Senijor разработчик",
      },
    },
    letsTalk: {
      title: "ОБСУДИМ?",
    },
    footer: {
      privacy: "Политика конфиденциальности",
      contacts: {
        linkedIn: "LinkedIn",
        dribbble: "Dribbble",
      },
      copyright: "©Все права защищены «Zero Liquid»",
    },
    mobileMenu: {
      joke:
        "Лучше пернуть как медведь, чем предательски шипеть © Писяпопа",
    },
    contact: {
      title: "Давайте обсудим ваш проект",
      subtitle: "Опишите идею, и мы предложим решение",
      fields: {
        name: "Как можно к вам обращаться?",
        project: "Название проекта",
        description: "Краткое описание проекта",
        budget: "Желаемый бюджет",
      },
      submit: "Связаться с менеджером",
      telegramMessage:
        "Здравствуйте! Меня зовут {name}.\nЯ хочу создать {project}.\nКраткое описание: {description}.\nБюджет проекта: {budget}.",
      productMessage:
        "Привет! Я заинтересовался вашим продуктом {title}. Можете детальнее про него рассказать?",
    },
  },
  es: {
    header: {
      logoSuffix: "LIQUID",
      menu: {
        about: "SOBRE NOSOTROS",
        portfolio: "PORTAFOLIO",
        experience: "EXPERIENCIA",
        team: "EQUIPO",
        contact: "CONTACTO",
      },
      languageLabel: "Idioma",
      languages: {
        en: "English",
        es: "Español",
        fr: "Français",
        ru: "Русский",
      },
    },
    main: {
      underheader: "Donde los pensamientos se transforman en forma y adquieren sentido",
    },
    about: {
      title: "Sobre nosotros",
      row1: {
        left: "WE ARE",
        right: "A TEAM OF EXPERTS",
      },
      row2: {
        left: "INSPIRED BY CUTTING-EDGE",
      },
      row3: {
        right: "TECHNOLOGIES AND",
      },
      row4: {
        left: "PRODUCT DEVELOPMENT",
      },
      stats: {
        experts: {
          number: "16",
          label: "EXPERTOS EN EL EQUIPO",
        },
        released: {
          number: "10",
          label: "PRODUCTOS LANZADOS",
        },
        ongoing: {
          number: "1",
          label: "PROYECTO EN CURSO",
        },
        best: {
          number: "2",
          label: "MEJORES PROYECTOS",
        },
      },
    },
    experience: {
      title: "Experiencia",
      cards: {
        blockchain: {
          header: "Desarrollo Web",
          description:
            "Creamos aplicaciones y servicios web modernos, desde landing pages hasta plataformas complejas. Diseñamos arquitectura, rendimiento y escalabilidad para negocios reales.",
        },
        uxui: {
          header: "Desarrollo WEB3",
          description:
            "Desarrollamos soluciones descentralizadas: smart contracts, dApps e integraciones blockchain. Garantizamos seguridad, transparencia y una infraestructura web3 fiable.",
        },
        mobile: {
          header: "Desarrollo en Telegram",
          description:
            "Creamos aplicaciones, bots y parsers para Telegram de cualquier complejidad. Automatizamos procesos, recopilamos datos y optimizamos la interacción con usuarios.",
        },
        qa: {
          header: "Scripts y Automatización",
          description:
            "Desarrollamos scripts, paneles y dashboards para tareas específicas. Optimizamos flujos de trabajo, aceleramos procesos y centralizamos datos.",
        },
        consulting: {
          header: "Backend y Arquitectura",
          description:
            "Diseñamos soluciones backend y APIs confiables. Aseguramos estabilidad, seguridad y preparación para altas cargas.",
        },
        data: {
          header: "Desarrollo Integral",
          description:
            "Gestionamos todo el ciclo: desde la idea hasta el soporte del producto. Elegimos tecnologías adecuadas y creamos soluciones que funcionan.",
        },
      },
    },
    projects: {
      title: "PROYECTOS.",
      cards: {
        drainer: {
          header: "Cartera WEB3",
          description:
            "Una cartera tecnológicamente imposible que logramos crear",
        },
        telegramPhish: {
          header: "Aplicación web Telegram",
          description:
            "Una experiencia de usuario increíble en el campo de las aplicaciones web de Telegram",
        },
        multiParser: {
          header: "Multi Parser",
          description:
            "Un analizador para anuncios en varias plataformas y canales de Telegram",
        },
      },
    },
    team: {
      title: "Equipo",
      positions: {
        founder: "Fundador y CTO",
        marketing: "Director de marketing",
        product: "Product Manager",
        backend: "Backend Lead",
        design: "Front-end Lead",
        community: "Senijor Dev",
      },
    },
    letsTalk: {
      title: "LET'S TALK",
    },
    footer: {
      privacy: "Política de privacidad",
      contacts: {
        linkedIn: "LinkedIn",
        dribbble: "Dribbble",
      },
      copyright: "©Todos los derechos reservados «Zero Liquid»",
    },
    mobileMenu: {
      joke:
        "Mejor rugir como un oso que sisear como un traidor © PisyaPopa",
    },
    contact: {
      title: "Hablemos de tu proyecto",
      subtitle: "Describe tu idea y volveremos con una propuesta",
      fields: {
        name: "¿Cómo podemos dirigirnos a ti?",
        project: "Nombre del proyecto",
        description: "Descripción corta del proyecto",
        budget: "Presupuesto deseado",
      },
      submit: "Contactar con el manager",
      telegramMessage:
        "Hola, mi nombre es {name}.\nQuiero crear {project}.\nDescripción corta: {description}.\nMi presupuesto es {budget}.",
      productMessage:
        "Hola, estoy interesado en su producto {title}. ¿Podrían contarme más sobre él?",
    },
  },
  fr: {
    header: {
      logoSuffix: "LIQUID",
      menu: {
        about: "À PROPOS",
        portfolio: "PORTFOLIO",
        experience: "EXPÉRIENCE",
        team: "ÉQUIPE",
        contact: "CONTACT",
      },
      languageLabel: "Langue",
      languages: {
        en: "English",
        es: "Español",
        fr: "Français",
        ru: "Русский",
      },
    },
    main: {
      underheader: "Où les pensées prennent forme et acquièrent un sens",
    },
    about: {
      title: "À propos",
      row1: {
        left: "WE ARE",
        right: "A TEAM OF EXPERTS",
      },
      row2: {
        left: "INSPIRED BY CUTTING-EDGE",
      },
      row3: {
        right: "TECHNOLOGIES AND",
      },
      row4: {
        left: "PRODUCT DEVELOPMENT",
      },
      stats: {
        experts: {
          number: "16",
          label: "EXPERTS DANS L’ÉQUIPE",
        },
        released: {
          number: "10",
          label: "PRODUITS LANCÉS",
        },
        ongoing: {
          number: "1",
          label: "PROJET EN COURS",
        },
        best: {
          number: "2",
          label: "MEILLEURS PROJETS",
        },
      },
    },
    experience: {
      title: "Expérience",
      cards: {
        blockchain: {
          header: "Développement Web",
          description:
            "Nous créons des applications et services web modernes, des landing pages aux plateformes complexes. Nous concevons une architecture performante et évolutive.",
        },
        uxui: {
          header: "Développement WEB3",
          description:
            "Nous développons des solutions décentralisées : smart contracts, dApps et intégrations blockchain. Nous garantissons sécurité, transparence et fiabilité web3.",
        },
        mobile: {
          header: "Développement Telegram",
          description:
            "Nous créons des applications, bots et parsers Telegram de toute complexité. Nous automatisons les processus et optimisons l’interaction utilisateur.",
        },
        qa: {
          header: "Scripts et Automatisation",
          description:
            "Nous développons des scripts, panneaux et dashboards adaptés à chaque besoin. Nous optimisons les flux et centralisons les données.",
        },
        consulting: {
          header: "Backend et Architecture",
          description:
            "Nous concevons des solutions backend et des API fiables. Nous assurons stabilité, sécurité et performance sous forte charge.",
        },
        data: {
          header: "Développement Complet",
          description:
            "Nous prenons en charge l’ensemble du cycle, de l’idée au support produit. Nous créons des solutions réellement efficaces.",
        },
      },
    },
    projects: {
      title: "PRODUCTS.",
      cards: {
        drainer: {
          header: "Portefeuille WEB3",
          description:
            "Un portefeuille technologiquement impossible que nous avons réussi à créer",
        },
        telegramPhish: {
          header: "Application Web Telegram",
          description:
            "Une expérience utilisateur incroyable dans le domaine des applications Web Telegram",
        },
        multiParser: {
          header: "Multi Parser",
          description:
            "Un analyseur syntaxique pour les publicités sur diverses plateformes et chaînes Telegram",
        },
      },
    },
    team: {
      title: "Équipe",
      positions: {
        founder: "Fondateur et CTO",
        marketing: "Directeur marketing",
        product: "Product Manager",
        backend: "Backend Lead",
        design: "Front-end Lead",
        community: "Senijor Dev",
      },
    },
    letsTalk: {
      title: "LET'S TALK",
    },
    footer: {
      privacy: "Politique de confidentialité",
      contacts: {
        linkedIn: "LinkedIn",
        dribbble: "Dribbble",
      },
      copyright: "©Tous droits réservés «Zero Liquid»",
    },
    mobileMenu: {
      joke:
        "Mieux vaut rugir comme un ours que siffler comme un traître © PisyaPopa",
    },
    contact: {
      title: "Parlons de votre projet",
      subtitle: "Décrivez votre idée et nous reviendrons vers vous avec une solution",
      fields: {
        name: "Comment pouvons-nous vous appeler ?",
        project: "Nom du projet",
        description: "Brève description du projet",
        budget: "Budget souhaité",
      },
      submit: "Contacter le manager",
      telegramMessage:
        "Bonjour, je m'appelle {name}.\nJe souhaite créer {project}.\nBrève description : {description}.\nLe budget est de {budget}.",
    },
  },
};

const savedLocale =
  (typeof window !== "undefined" && window.localStorage.getItem("locale")) ||
  "en";

export const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: "en",
  messages,
});


